import { RegionLocale } from '~/infra/locale';

export interface City {
  id: RegionLocale;
  title: string;
}

export const CITIES: City[] = [
  { id: 'msk', title: 'Москва' },
  { id: 'spb', title: 'Санкт-Петербург' },
];
